// extracted by mini-css-extract-plugin
module.exports = {"advantageWrapper":"advantage-card_advantageWrapper__hpxih","advantageTitle":"advantage-card_advantageTitle___h1K7"};